import React from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './AppDownloadButtons.css';

const AppDownloadButtons = ({ variant = 'horizontal' }) => {
  const { t } = useTranslation();
  
  const androidUrl = process.env.REACT_APP_ANDROID_APP_URL;
  const iosUrl = process.env.REACT_APP_IOS_APP_URL;

  // Si no hay URLs configuradas, no mostrar nada
  if (!androidUrl && !iosUrl) {
    return null;
  }

  return (
    <div className={`app-download-buttons ${variant}`}>
      {androidUrl && (
        <a 
          href={androidUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="app-download-btn android"
          aria-label={t('download_android_app')}
        >
          <FaGooglePlay className="app-icon" />
          <div className="app-download-text">
            <span className="download-label">{t('get_it_on')}</span>
            <span className="store-name">Google Play</span>
          </div>
        </a>
      )}
      
      {iosUrl && (
        <a 
          href={iosUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="app-download-btn ios"
          aria-label={t('download_ios_app')}
        >
          <FaApple className="app-icon" />
          <div className="app-download-text">
            <span className="download-label">{t('download_on')}</span>
            <span className="store-name">App Store</span>
          </div>
        </a>
      )}
    </div>
  );
};

export default AppDownloadButtons;
